import { useCallback } from 'react';

import { getChangeEvent } from 'components/modules/Insurance/Insurance.helpers';
import { VOID_FUNCTION } from 'constants/index';

export const useGenderSelectorPresenter = ({ name, onChange: onChangeProp = VOID_FUNCTION }) => {
  const onChange = useCallback(
    (event) => {
      const { value } = getChangeEvent(event);
      const result = Number(value);

      onChangeProp(name ? { [name]: result } : result);
    },
    [name, onChangeProp]
  );

  return { onChange };
};
